import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { useTheme, useMediaQuery, Box, Stack } from '@mui/material';
import KenButton from '../../Components/KenButton';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import moment from 'moment';
import { getFeeInstallmentDetails } from '../../Utils/apiServices';
import KenLoader from '../KenLoader';

const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.palette.card.backgroundColor,
    mixBlendMode: 'normal',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    borderRadius: '12px',
    border: 'none',
    height: '100%',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      boxShadow: 'unset',
    },
  },
  amount: {
    'font-style': 'normal',
    'font-weight': '500',
    'font-size': '14px',
    'line-height': '100%',
    'text-align': 'right',
    'text-transform': 'capitalize',
    color: theme.palette.KenColors.neutral900,
  },
  applicationName: {
    color: theme.palette.KenColors.grey2,
    fontWeight: 500,
  },
  applicationNumber: {
    color: theme.palette.KenColors.grey2,
    fontWeight: '500 !important',
    fontSize: '14px',
  },
  due: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '500',
      'font-size': '14px',
      'line-height': '100%',
      'text-align': 'right',
      'text-transform': 'capitalize',
      color: theme.palette.KenColors.statusRed,
    },
  },
  btn: {
    width: '100%',
    maxWidth: theme.spacing(22.5),
    padding: '20px !important',
    lineHeight: '20px !important',
    background: '#F15A2B !important',
  },
  mobilBtn: {
    'border-radius': '50% !important',
    height: '48px !important',
    width: '48px !important',
    padding: '0 !important',
    'min-width': '48px',
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    '& > span:first-child': {
      margin: 'auto',
    },
  },
  bottomBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
  },

  // New Card
  cardContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    flexDirection: 'column',
    gap: '20px',
    background: 'rgba(247, 248, 251, 1)',
    boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.04)',
    borderRadius: '12px',
    padding: '24px',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 0px 12px 0px',
    gap: '20px',
    borderBottom: '1px solid rgba(156, 156, 156, 1)',
  },
  courseInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  courseTitle: {
    color: 'rgba(6, 25, 56, 1)',
    fontSize: '18px',
    fontWeight: 500,
  },
  courseTag: {
    color: 'rgba(81, 81, 81, 1)',
    fontSize: '14px',
    fontWeight: 500,
    background: 'rgba(255, 255, 255, 1)',
    padding: '8px 20px',
    borderRadius: '100px',
  },
  appId: {
    color: 'rgba(80, 95, 121, 1)',
    fontSize: '16px',
    fontWeight: 400,
  },
  feeSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '4px',
  },
  feeLabel: {
    color: 'rgba(80, 95, 121, 1)',
    fontSize: '16px',
    fontWeight: 400,
  },
  feeDate: {
    color: 'rgba(231, 85, 71, 1)',
    fontSize: '14px',
    fontWeight: 400,
    marginTop: '4px',
  },
  feeAmount: {
    color: 'rgba(6, 25, 56, 1)',
    fontSize: '20px',
    fontWeight: 400,
  },
}));

export function MobilePaymentCard(props) {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <React.Fragment>
      <CardContent>
        <Stack p={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Typography variant="body6" className={classes.applicationName}>
            {props?.formTitle}
          </Typography>
          <Typography variant="h5" className={classes.applicationNumber}>
            App No: {props?.applicationNumber}
          </Typography>
        </Stack>
        <Stack p={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Stack direction={'column'} gap={"6px"}>
            {props?.feeDetailsList[0]?.name && (
              <Typography variant="h5" style={{ color: '#505F79', fontSize: '14px', marginTop: '12px', fontWeight: 500 }}>
                {props?.feeDetailsList[0]?.name}
              </Typography>
            )}
            {props?.feeDetailsList[0]?.dueDate && (
              <Grid item>
                <Typography fontSize={14} className={classes.feeDate}>
                  {moment(props?.feeDetailsList[0]?.dueDate, 'YYYY-MM-DD').format('DD MMM YYYY')}
                </Typography>
              </Grid>
            )}
          </Stack>
          <Typography className={classes.fee} fontSize={'20px'}>
            ₹ {props?.feeAmount}
          </Typography>
        </Stack>
      </CardContent>
      <div className={classes.bottomBox}>
        <Divider style={{ margin: '10px' }} />
        <CardActions
          sx={{
            padding: theme.spacing(2),
            alignItems: 'baseline',
            justifyContent: 'center',
          }}
        >
          <KenButton
            buttonClass={classes.btn}
            label={props?.dueFee?.status === 'Partial' || props?.dueFee?.status === 'Due' ? 'Pay Now' : props?.buttonTitle ? props?.buttonTitle : 'View Details'}
            variant="roundedButton"
            onClick={() => {
              props.handleViewDetails();
            }}
          />
        </CardActions>
      </div>
    </React.Fragment>
  );
}

export default function PaymentCard(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));
  const [feeAmount, setFeeAmount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (props?.applicationId) {
      setLoading(true);
      getFeeInstallmentDetails(props?.applicationId)
        .then((res) => {
          let customAmount = 0;
          for (let i = 0; i < res.length; i++) {
            const element = res[i];
            customAmount = customAmount + element?.Remaining_Amount__c;
          }
          setFeeAmount(customAmount);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    }
  }, [props?.applicationId]);

  const cardChanged = (
    <Box component="div" className={classes.cardContainer}>
      <Box component="div" className={classes.header}>
        <Box component="div" className={classes.courseInfo}>
          <Typography className={classes.courseTitle}>{props?.formTitle}</Typography>
        </Box>
        <Typography className={classes.appId}>{props?.applicationName}</Typography>
      </Box>

      <Box component="div" className={classes.feeSection}>
        <Box component="div">
          {props?.feeDetailsList[0]?.name && <Typography className={classes.feeLabel}>{props?.feeDetailsList[0]?.name}</Typography>}
          {props?.feeDetailsList[0]?.dueDate && <Typography className={classes.feeDate}>{moment(props?.feeDetailsList[0]?.dueDate, 'YYYY-MM-DD').format('DD MMM YYYY')}</Typography>}
        </Box>
        <Typography className={classes.fee} fontSize={'20px'}>
          ₹ {feeAmount}
        </Typography>
      </Box>
      <KenButton
        buttonClass={classes.btn}
        label={'View Details'}
        variant="roundedButton"
        onClick={() => {
          props.handleViewDetails();
        }}
      />
    </Box>
  );

  return (
    <>
      {loading && <KenLoader />}
      {isMobileScreen ? (
        <Card variant="outlined" className={classes.container} style={{ position: 'relative', display: 'grid' }}>
          <MobilePaymentCard {...props} feeAmount={feeAmount} />
        </Card>
      ) : (
        cardChanged
      )}
    </>
  );
}
